import { Box, Flex, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Colors } from '~/themes/colors';
import { InvitedProfessionalPill } from './InvitedProfessionalPill';

type TProfessionalType = 'favorite' | 'recent' | 'new';

export interface IInvitedProfessional {
  id: string;
  name: string;
  type: TProfessionalType;
  photoUrl?: string;
}

interface IInvitingSectionProps {
  invited: IInvitedProfessional[];
  onRemove: (id: string) => void;
}

export const InvitingSection = ({ invited, onRemove }: IInvitingSectionProps) => {
  if (invited.length === 0) {
    return (
      <Box
        data-testid="inviting-section-empty"
        data-cy="inviting-section-empty"
        style={{
          border: `1.5px solid ${Colors.neutral_100}`,
          borderRadius: 8,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 24,
        }}
      >
        <Typography variant="body1" italic color={colors.neutral[500]}>
          No professionals invited yet. Pick from the lists above.
        </Typography>
      </Box>
    );
  }

  const sorted = [...invited].sort((a, b) => {
    const aFav = a.type === 'favorite' ? 0 : 1;
    const bFav = b.type === 'favorite' ? 0 : 1;
    return aFav - bFav;
  });

  return (
    <Box
      data-testid="inviting-section"
      data-cy="inviting-section"
      style={{
        border: `1.5px solid ${Colors.neutral_100}`,
        borderRadius: 8,
        padding: '12px 16px',
      }}
    >
      <Flex direction="row" align="start" gap={3}>
        <Typography
          bold
          variant="body1"
          color={Colors.neutral_600}
          style={{ flexShrink: 0, lineHeight: '38px' }}
        >
          {`Inviting (${invited.length}):`}
        </Typography>
        <Flex direction="row" wrap="wrap" gap={2} style={{ flex: 1, minWidth: 0 }}>
          {sorted.map((pro) => (
            <InvitedProfessionalPill
              key={pro.id}
              name={pro.name}
              type={pro.type}
              photoUrl={pro.photoUrl}
              onRemove={() => onRemove(pro.id)}
            />
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};
